module.exports = __webpack_public_path__ + "img/play-market-png.abebe156.jpg";